<script setup>

</script>

<template>
  <h1 class="pageTitle">Terms of service</h1>
  <div class="legalPage">
    <div class="legalBackground">
      <h1 class="legalHeader">1. Terms</h1>
      <p>
        By accessing this website, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws.

        If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law unless marked otherwise.
      </p>
      <h1 class="legalHeader">2. Disclaimer</h1>
      <p>
        The materials on Studio Idem's website are provided on an 'as is' basis. Studio Idem makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.

        Further, Studio Idem does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.

      </p>
      <h1 class="legalHeader">3. Limitations</h1>
      <p>
        In no event shall Studio Idem or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Studio Idem's website, even if Studio Idem or a Studio Idem authorized representative has been notified orally or in writing of the possibility of such damage.

        Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
      </p>
      <h1 class="legalHeader">4. Accuracy of materials</h1>
      <p>
        The materials appearing on Studio Idem's website could include technical, typographical, or photographic errors. Studio Idem does not warrant that any of the materials on its website are accurate, complete or current. Studio Idem may make changes to the materials contained on its website at any time without notice. However Studio Idem does not make any commitment to update the materials.

      </p>
      <h1 class="legalHeader">5. Links</h1>
      <p>
        Studio Idem has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Studio Idem of the site. Use of any such linked website is at the user's own risk.

      </p>
      <h1 class="legalHeader">6. Modifications</h1>
      <p>
        Studio Idem may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.

      </p>
      <h1 class="legalHeader">7. Governing Law</h1>
      <p>
        These terms and conditions are governed by and construed in accordance with the laws of Netherlands and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
      </p>
    </div>
  </div>
</template>

<style>
.legalPageHeader{
  text-align: center;
  font-family: "Archivo SemiBold";
  font-size: 2.5vw;
  margin-bottom: 2.5vw;
}
.legalPage{
  width: 95%;
  border-radius: 0 0 1vw 1vw;
  background-color: #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
}
.legalBackground{
  background-color: white;
  border-radius: 1vw;
  width: 87%;
  margin: 2.5vw 0 4vw 0;
  text-align: left;
  padding: 1vw 2vw 1vw 2vw;
}
.legalHeader{
  font-family: "Archivo Light";
}
</style>